@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/screen-width-breakpoints.module.less';

.modal {
  .modal-background {
    height: 100%;
    width: 100%;
    background: @modal-portal--background-color;
    opacity: 0;
    position: fixed;
    top: 0;
    left: 0;
  }

  &:last-of-type {
    .modal-background {
      opacity: 1;
    }
  }

  .modal-positioning-wrapper {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    bottom: 0;
    left: 0;

    @media @tablet, @desktop, @widescreen, @ultrawide {
      right: 0;

      :global(.sidebar-open) & {
        right: var(--shippy-sidebar-width);
      }
    }
  }

  .modal-component-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 30px;
    z-index: 2;

    @media @mobile {
      padding: 0;
    }
  }

  .modal-positioning-wrapper-background {
    position: fixed;
    inset: 0;
  }
}
